<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <form @submit.prevent="update">
        <signup-card>
          <h6>&nbsp;</h6>
          <h3 class="title text-center" slot="title"><br />會員資料</h3>

          <div
            class="md-layout-item mr-auto"
            slot="content-right"
          >

            <md-field
              class="md-form-group md-invalid"
              style="margin-bottom: 2rem"
            >
              <md-icon>fingerprint</md-icon>
              <label>手機號碼(登入帳號)</label>
              <md-input v-model="user.mobile" disabled/>
            </md-field>

            <md-field
              class="md-form-group md-invalid"
              style="margin-bottom: 2rem"
            >
              <md-icon>face</md-icon>
              <label>姓名</label>
              <md-input v-model="user.name" disabled/>
              <!-- <validation-error :errors="apiValidationErrors.name" /> -->
            </md-field>


            <md-field
              class="md-form-group md-invalid"
              style="margin-bottom: 2rem"
            >
              <md-icon>email</md-icon>
              <label>Email</label>
              <md-input v-model="user.email"/>
              <!-- <validation-error :errors="apiValidationErrors.email" /> -->
            </md-field>

            <md-field
              class="md-form-group md-invalid"
              style="margin-bottom: 2rem"
            >
              <md-icon>transgender</md-icon>
              <label>性別</label>
              <md-select v-model="user.sex" style="margin-left: 16px">
                <md-option value="0">女</md-option>
                <md-option value="1">男</md-option>
                <md-option value="2">不好說</md-option>
              </md-select>
            </md-field>

            <md-datepicker v-model="user.birthday" >
              <label>生日</label>
            </md-datepicker>

            <div class="button-container">
              <md-button
                class="md-success md-round mt-4"
                type="submit"
                slot="footer"
              >
                更新會員資料
              </md-button>
            </div>
          </div>
        </signup-card>
      </form>
    </div>

    <div class="md-layout-item md-size-100">
      <form ref="password_form" @submit.prevent="changePassword">
        <signup-card>
          <h3 class="title text-center" slot="title"><br />變更密碼</h3>
          <div
            class="md-layout-item mr-auto"
            slot="content-right"
          >
            <md-field
              class="md-form-group md-invalid"
              style="margin-bottom: 2rem"
            >
              <md-icon>lock_outline</md-icon>
              <label>新密碼 (最少4個字)</label>
              <md-input v-model="password" type="password" />
            </md-field>

            <md-field class="md-form-group md-invalid">
              <md-icon>lock_outline</md-icon>
              <label>確認密碼</label>
              <md-input v-model="password_confirmation" type="password" />
            </md-field>

            <div class="button-container">
              <md-button
                class="md-success md-round mt-4"
                type="submit"
                slot="footer"
              >
                變更密碼
              </md-button>
            </div>
          </div>
        </signup-card>
      </form>
    </div>
  </div>

  
</template>
<script>
import { SignupCard, ValidationError } from "@/components";
import formMixin from "@/mixins/form-mixin";

export default {
  components: {
    SignupCard,
    // ValidationError,
  },
  mixins: [formMixin],
  data() {
    return {
      user: {
        id: 0,
        name: null,
        sex: 0,
        birthday: null
        
      },

      password: null,
      password_confirmation: null,
    };
  },

  created() {
    this.getProfile();
  },

  methods: {
    async getProfile() {
      await this.$store.dispatch("profile/me")
      this.user = await this.$store.getters["profile/me"]
    },

    async update() {
      try {
        await this.$store.dispatch("profile/update", this.user);
        await this.$store.dispatch(
          "alerts/success",
          "更新成功."
        );
      } catch (e) {
        await this.$store.dispatch(
          "alerts/error",
          "Oops, 請填寫完整資料"
        );
        this.setApiValidation(e.response.data.errors);
      }
    },

    async changePassword() {
      if (this.password != this.password_confirmation || this.password.length < 4) {
        await this.$store.dispatch(
          "alerts/error",
          "密碼輸入錯誤."
        );
        return;
      }
      const user = {
        id: this.user.id,
        type: "users",
        password: this.password,
        password_confirmation: this.password_confirmation,
      };

      try {
        await this.$store.dispatch("profile/changePassword", user);
        await this.$store.dispatch(
          "alerts/success",
          "密碼更新完成."
        );

        this.$refs["password_form"].reset();
      } catch (e) {
        await this.$store.dispatch(
          "alerts/error",
          "Oops, something went wrong!"
        );
      }
    },

  },
};
</script>
